import { IconButton, Typography, withStyles } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.morePaper,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(1.5),
    cursor: "pointer",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, disableTypography, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {!disableTypography && (
        <Typography align="center" variant="h6">
          {children}
        </Typography>
      )}
      {disableTypography && children}
      {onClose ? (
        <IconButton size="small" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

DialogTitle.defaultProps = {
  disableTypography: false,
};

export default DialogTitle;
